<template>
  <div class="card-view row">
    <div class="col-md-12 check-all">
      <div class="checkbox checkbox-custom checkbox-primary">
        <input
          type="checkbox"
          @click.stop="$parent.onSelectAllRows"
          :checked="$parent.isAllSelected"
        />
        <label></label>
        <span>Marcar / Desmarcar todo</span>
      </div>
    </div>
    <div class="col-md-4" v-for="(row, i) in data" :key="i">
      <div class="class-card">
        <header
          class="card-header"
          :style="`background:#${row.color ? row.color : DEFAULT_COLOR};`"
        >
          <h3 class="checkbox checkbox-custom checkbox-primary">
            <input
              type="checkbox"
              :checked="$parent.isRowSelected(row)"
              @click.stop="$parent.onSelectRow(row)"
            />
            <label></label>
            <span class="title">{{ row.name }}</span>
            <span class="info-icon" @click.stop="$parent.onRowClicked(row)"
              ><i class="fa fa-info"></i
            ></span>
          </h3>
        </header>
        <section class="card-body">
          <div
            class="row"
            style="margin: 0px; padding-top: 10px; padding-bottom: 10px"
          >
            <div class="col-md-4 col-sm-12 card-image">
              <div :style="`background: #${row.color}`">
                <img :src="row.image | s3url" />
              </div>
            </div>
            <div class="col-md-8 col-sm-12 body-content">
              <div>
                Grado: <b>{{ row.gradeName }}</b>
              </div>
              <div>
                Grupo: <b>{{ row.groupName }}</b>
              </div>
              <div>
                Ruta: <b>{{ row.pathwayName }}</b>
              </div>
              <div>
                Idioma: <b>{{ row.language }}</b>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["moduleSource"],
  data() {
    return {
      DEFAULT_COLOR: "983ADC",
    };
  },
  computed: {
    totalRows() {
      return this.data.length;
    },
    data() {
      return this.$store.state[this.moduleSource].table.data;
    },
    selectedRows() {
      return this.$store.state[this.moduleSource].table.selection;
    },
  },
};
</script>

<style lang="scss">
$borderRadius: 3px;

.card-view {
  margin: 0 auto;
  .class-card {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    margin-bottom: 25px;
    border-bottom-left-radius: $borderRadius;
    border-bottom-right-radius: $borderRadius;
    header {
      &.card-header {
        padding: 5px;
        border-top-left-radius: $borderRadius;
        border-top-right-radius: $borderRadius;

        h3 {
          margin-bottom: 0px;
          display: flex;
          align-items: center;
          position: relative;
          color: white;

          label {
            margin-right: 5px;
          }

          .title {
            font-size: 17px;
            text-shadow: 0 1px 1px #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: calc(100% - 30px);
          }

          .info-icon {
            position: absolute;
            right: 0;
            font-size: 15px;
            font-weight: normal;
            width: 20px;
            height: 20px;
            border: 1px solid white;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
        }
      }
    }
    section {
      &.card-body {
        .card-image {
          display: flex;
          align-items: center;
          padding: 0 !important;
          > div {
            width: 60px;
            height: 60px;
            border-radius: 100%;
            border: 1px solid #eee;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          img {
            width: 100%;
            object-fit: contain;
          }
        }

        .body-content {
          > div {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .check-all {
    .checkbox-custom {
      display: flex;
      align-items: center;
      label {
        margin-right: 5px;
      }
      span {
        font-size: 18px;
        font-weight: 400;
        color: #3c3c3c;
      }
    }
  }
}
</style>
